import { render, staticRenderFns } from "./tcktwos.vue?vue&type=template&id=8a56dfc2&"
import script from "./tcktwos.vue?vue&type=script&lang=js&"
export * from "./tcktwos.vue?vue&type=script&lang=js&"
import style0 from "./tcktwos.vue?vue&type=style&index=0&id=8a56dfc2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports